import { httpClient } from '@/shared/api/client.ts'
import { LoginRequest, LoginResponse } from '@/domains/auth/api/types'

export function login({ walletAddress, nonce, signature, message, type, isMobile, deviceId }: LoginRequest) {
  return httpClient
    .post('member/login', {
      json: {
        walletAddress,
        nonce,
        signature,
        message,
        type,
        isMobile,
        deviceId,
      },
    })
    .json<LoginResponse>()
}
